module.exports = __webpack_public_path__ + "static/header-48172aca2dad60724d130cc7ba03db47.png";